// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-31be948e] .app-highlight-table-item {\n  background: #f9d48f;\n}\n.collapse[data-v-31be948e] {\n  margin: 8px 0;\n}\n.alert[data-v-31be948e] {\n  margin-top: 8px;\n}\n.header-btn-wrap[data-v-31be948e] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.header-btn-wrap .btn[data-v-31be948e] {\n  margin-right: 15px;\n}\n.collapse-tips[data-v-31be948e] {\n  color: #67C23A;\n}\n", ""]);
// Exports
module.exports = exports;
